"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.NodeInterface__factory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: 'address',
                name: 'sender',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: 'deposit',
                type: 'uint256',
            },
            {
                internalType: 'address',
                name: 'destAddr',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: 'l2CallValue',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: 'maxSubmissionCost',
                type: 'uint256',
            },
            {
                internalType: 'address',
                name: 'excessFeeRefundAddress',
                type: 'address',
            },
            {
                internalType: 'address',
                name: 'callValueRefundAddress',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: 'maxGas',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: 'gasPriceBid',
                type: 'uint256',
            },
            {
                internalType: 'bytes',
                name: 'data',
                type: 'bytes',
            },
        ],
        name: 'estimateRetryableTicket',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'pure',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: 'batchNum',
                type: 'uint256',
            },
            {
                internalType: 'uint64',
                name: 'index',
                type: 'uint64',
            },
        ],
        name: 'lookupMessageBatchProof',
        outputs: [
            {
                internalType: 'bytes32[]',
                name: 'proof',
                type: 'bytes32[]',
            },
            {
                internalType: 'uint256',
                name: 'path',
                type: 'uint256',
            },
            {
                internalType: 'address',
                name: 'l2Sender',
                type: 'address',
            },
            {
                internalType: 'address',
                name: 'l1Dest',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: 'l2Block',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: 'l1Block',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: 'timestamp',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: 'amount',
                type: 'uint256',
            },
            {
                internalType: 'bytes',
                name: 'calldataForL1',
                type: 'bytes',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
];
class NodeInterface__factory {
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.NodeInterface__factory = NodeInterface__factory;
NodeInterface__factory.abi = _abi;
